module.exports = __webpack_public_path__ + "img/yy-s7.1448e83d.svg";